export const mockAPIPath = {
    ACTIVITY_LOG : "./data/ActivityLog.json"
};

export const serverAPIPath = {
    ACTIVITY_LOG: "/activity-logs"
};